import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { ConfigurationTable } from "@/components/dashboard/ConfigurationTable";
import { appConfig } from "@/utils/config";

/** Displays the frontend's own local configuration - read-only, no editing or persistence. */
export function ConfigurationSection(): React.JSX.Element {
  return (
    <StatusCard title="Configuration">
      <ConfigurationTable rows={[{ key: "API Endpoint", value: appConfig.apiBaseUrl }]} />
    </StatusCard>
  );
}
